<template>
  <div v-if="storyDetails" class="col-12 col-md-4 story-wrap">
    <div class="story-card">
      <a v-bind:href="'/pages/common-thread-story/' + storyDetails.vanityUrl">
        <div class="story-img">
          <img
            v-if="storyDetails.heroMedia.heroPhoto.data"
            :src="storyDetails.heroMedia.heroPhoto.data.attributes.url"
            class="img"
          />
          <img
            v-else
            class="img"
            src="https://cdn.shopify.com/s/files/1/0281/7544/files/default-insta-header.jpg?v=1701213684"
          />
        </div>
        <div class="story-content">
          <span class="cat">{{
            storyDetails.category.data.attributes.categoryName
          }}</span>
          <span
            v-if="storyDetails.storyType == 'video'"
            class="video-icon"
          ></span>
          <h2 class="display-5">{{ storyDetails.title }}</h2>
          <p>
            {{ storyDetails.description }}
          </p>
          <div class="story-btm">
            <span class="storyl">
              <span class="date"
                >{{ formatDateString(storyDetails.posted_date) }}
              </span>
              &bullet;
              <span class="rtime">
                <div v-if="storyDetails.storyType == 'story'">
                  {{ storyDetails.readTime }} min read
                </div>
                <div v-else>
                  {{ storyDetails.readTime }}
                </div>
              </span>
            </span>
            <span v-if="storyDetails.storyType == 'story'" class="link-reveal"
              >Read Full Story ></span
            >
            <span v-else class="link-reveal">View More ></span>
          </div>
        </div>
        <!--.story-content-->
      </a>
    </div>
  </div>
  <!-- .col-md-4 -->
</template>

<script src="./ctrl-story-card.js"></script>
